import React from 'react';
import { Layout } from 'antd';
import { Link } from 'react-router-dom';
import TerraLogo from 'assets/images/v2/terra_logo.png';
import './AppHeader.scss';
import { Routes } from 'constants/routes';

const { Header } = Layout;

const AppHeaderWithLogoOnly: React.FC = () => {
  return (
    <Header className="app-header-v2" style={{ width: '100%' }}>
      <div className="header-row">
        <div className="app-logo">
          <Link to={Routes.v2_projectList}>
            <img src={TerraLogo} alt="logo" />
          </Link>
        </div>
      </div>
    </Header>
  );
};

export default AppHeaderWithLogoOnly;
